const locale = (state = {
  value: 'nl',
  hasTranslation: false,
}, action) => {
  switch(action.type) {
    case 'UPDATE_LOCALE':
      return Object.assign({}, state, { value: action.locale, hasTranslation: action.hasTranslation });
    default:
      return state;
  }
};

export default locale;



// WEBPACK FOOTER //
// ./src/reducers/locale/locale.js